import React from "react";

const SECTIONS = [
  {
    heading: "What we collect",
    items: [
      "Details you give us: name, phone number, email, city, and project details such as marble type, quantity and timeline.",
      "Details from Meta lead forms: whatever you choose to submit in a Facebook or Instagram lead ad.",
      "Technical data: pages visited, device and browser type, and approximate location, collected through cookies and tools like Google Ads, Google Analytics and the Meta Pixel.",
      "Messages you send us by email or WhatsApp.",
    ],
  },
  {
    heading: "How we use it",
    items: [
      "To respond to your enquiry and plan your Kishangarh sourcing visit.",
      "To introduce you to relevant vendors and help with selection and price negotiation.",
      "To follow up about your project and, where you've agreed, to share updates and offers.",
      "To measure and improve our website and advertising.",
    ],
  },
  {
    heading: "Who we share it with",
    items: [
      "Vendors or wholesalers, only when needed to arrange your visit or quote, and only the details needed for that.",
      "Service providers that run our website, email, analytics and advertising (for example Google and Meta).",
      "Authorities, if the law requires it.",
      "We do not sell your personal information.",
    ],
  },
  {
    heading: "Cookies and advertising",
    body:
      "We use cookies and pixels to understand site usage and show relevant ads. You can block or clear cookies in your browser settings and adjust ad preferences in your Google and Meta accounts.",
  },
  {
    heading: "How long we keep it",
    body:
      "We keep enquiry details for 24 months after our last interaction, or longer if the law requires. You can ask us to delete them sooner.",
  },
  {
    heading: "Security",
    body:
      "We use reasonable technical and organisational measures to protect your information. No online system is completely secure, but we take care to limit access.",
  },
  {
    heading: "Your choices",
    body:
      "You can ask us to access, correct or delete your information, or withdraw consent for marketing messages, at any time by writing to the email below. We'll respond within 30 days.",
  },
  {
    heading: "Children",
    body:
      "Our services are not directed at anyone under 18, and we don't knowingly collect their data.",
  },
  {
    heading: "Changes",
    body: "We may update this policy and will change the date above when we do.",
  },
];

const PrivacyPolicy = () => {
  return (
    <main
      data-testid="privacy-policy-page"
      className="min-h-screen bg-brand-charcoal text-brand-cream px-6 py-24 md:py-32"
    >
      <div className="editorial-container max-w-2xl">
        <p
          data-testid="privacy-policy-eyebrow"
          className="font-sans text-[11px] uppercase tracking-[0.3em] text-brand-gold/80 mb-5"
        >
          Legal
        </p>
        <h1
          data-testid="privacy-policy-heading"
          className="font-serif font-light leading-tight mb-3"
          style={{ fontSize: "clamp(2.25rem, 5vw, 3.25rem)" }}
        >
          Privacy Policy
        </h1>
        <p
          data-testid="privacy-policy-updated"
          className="font-sans text-sm text-brand-cream/45 mb-14"
        >
          Last updated: 2 October 2026
        </p>

        <p className="font-sans text-base text-brand-cream/75 leading-relaxed mb-14">
          Aurevia Stones (&ldquo;we&rdquo;, &ldquo;us&rdquo;) helps homeowners,
          designers and builders source marble from wholesale markets in
          Rajasthan. This page explains what personal information we collect
          through aureviastones.com, our Instagram and Facebook ads, and
          WhatsApp, and how we use it.
        </p>

        <div className="space-y-12">
          {SECTIONS.map((section) => (
            <section
              key={section.heading}
              data-testid={`privacy-section-${section.heading
                .toLowerCase()
                .replace(/\s+/g, "-")}`}
            >
              <h2 className="font-serif text-xl md:text-2xl text-brand-gold/90 mb-4">
                {section.heading}
              </h2>
              {section.body && (
                <p className="font-sans text-base text-brand-cream/70 leading-relaxed">
                  {section.body}
                </p>
              )}
              {section.items && (
                <ul className="space-y-3">
                  {section.items.map((item, idx) => (
                    <li
                      key={idx}
                      className="font-sans text-base text-brand-cream/70 leading-relaxed pl-5 relative"
                    >
                      <span className="absolute left-0 top-[0.6em] w-1.5 h-1.5 rounded-full bg-brand-gold/50" />
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}

          <section data-testid="privacy-section-contact">
            <h2 className="font-serif text-xl md:text-2xl text-brand-gold/90 mb-4">
              Contact
            </h2>
            <p className="font-sans text-base text-brand-cream/70 leading-relaxed">
              Kshitij Gupta
              <br />
              Email:{" "}
              <a
                href="mailto:kshitij.gupta@aureviastones.com"
                data-testid="privacy-contact-email"
                className="text-brand-gold hover:text-brand-gold/80 transition-colors"
              >
                kshitij.gupta@aureviastones.com
              </a>
              <br />
              Phone:{" "}
              <a
                href="tel:+918796564619"
                data-testid="privacy-contact-phone"
                className="text-brand-gold hover:text-brand-gold/80 transition-colors"
              >
                +91 87965 64619
              </a>
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
